import React from "react";
import { Send, Check, Loader2 } from "lucide-react";
import { Section, StepBadge } from "./ui";

function getSubmitButton({ sending, submitted }) {
  if (sending) return { icon: <Loader2 className="w-4 h-4 animate-spin" />, label: "Enviando..." };
  if (submitted) return { icon: <Check className="w-5 h-5" />, label: "Solicitud enviada" };
  return { icon: <Send className="w-4 h-4" />, label: "Enviar solicitud de reserva" };
}

export default function ContactStep({ state, set, budget, onSubmit, submitted, sending }) {
  const submitEnabled =
    budget.ready && state.name.trim().length > 0 && /\S+@\S+\.\S+/.test(state.email) && !sending;
  const { icon, label } = getSubmitButton({ sending, submitted });

  return (
    <Section>
      <div id="reserva" />
      <StepBadge n={5} title="Solicita tu reserva" subtitle="Te confirmamos disponibilidad por email" />
      {!budget.ready && (
        <div className="mb-4 rounded-lg bg-[#f6eef0] px-4 py-2.5 text-sm text-[#6d5a5e]">
          Completa el vehículo y las fechas para poder enviar tu solicitud.
        </div>
      )}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-semibold text-[#2a1a1e] mb-1.5">Nombre</label>
          <input type="text" className="veysa-input" placeholder="Tu nombre" value={state.name} onChange={(e) => set({ name: e.target.value })} />
        </div>
        <div>
          <label className="block text-sm font-semibold text-[#2a1a1e] mb-1.5">Email</label>
          <input type="email" className="veysa-input" placeholder="tucorreo@email.com" value={state.email} onChange={(e) => set({ email: e.target.value })} />
        </div>
      </div>
      <div className="mt-4">
        <label className="block text-sm font-semibold text-[#2a1a1e] mb-1.5">Teléfono (opcional)</label>
        <input type="tel" className="veysa-input" placeholder="+34 ..." value={state.phone} onChange={(e) => set({ phone: e.target.value })} />
      </div>
      <div className="mt-4">
        <label className="block text-sm font-semibold text-[#2a1a1e] mb-1.5">Comentarios (opcional)</label>
        <textarea rows={3} className="veysa-input resize-none" placeholder="Franja horaria de recogida, necesidades especiales..." value={state.comments} onChange={(e) => set({ comments: e.target.value })} />
      </div>

      <button
        type="button"
        disabled={!submitEnabled}
        onClick={onSubmit}
        className={`mt-5 w-full inline-flex items-center justify-center gap-2 rounded-xl px-5 py-3.5 font-semibold transition-all duration-200 ${
          submitEnabled
            ? "bg-[#631024] text-white hover:bg-[#7a1530] hover:shadow-lg hover:shadow-[#631024]/20 active:scale-[0.99]"
            : "bg-[#e8dcde] text-[#a99ba0] cursor-not-allowed"
        }`}
      >
        {icon}
        {label}
      </button>
      <p className="text-xs text-[#9b8388] mt-2 text-center">
        Recibirás una solicitud <strong className="text-[#6d5a5e]">provisional</strong> por email. La confirmación final llegará tras revisar la disponibilidad.
      </p>
    </Section>
  );
}
